module.exports = __webpack_public_path__ + "static/media/male-2.5d4b4274.svg";